import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import LoginPage from "@/pages/LoginPage";

export const AuthGate = ({ children }) => {
  const [authed, setAuthed] = useState(null);
  const check = useCallback(async () => {
    try { const { data } = await api.get("/auth/status"); setAuthed(!!data.authenticated); }
    catch { setAuthed(false); }
  }, []);
  useEffect(() => {
    check();
    const off = () => setAuthed(false);
    window.addEventListener("catalog-unauthorized", off);
    return () => window.removeEventListener("catalog-unauthorized", off);
  }, [check]);
  if (authed === null) return <div className="min-h-screen bg-stone-100" data-testid="auth-checking" />;
  if (!authed) return <LoginPage onSuccess={() => setAuthed(true)} />;
  return children;
};

export const LogoutButton = ({ className = "" }) => {
  const [busy, setBusy] = useState(false);
  const out = async () => {
    setBusy(true);
    try { await api.post("/auth/logout"); } finally { window.location.assign("/"); }
  };
  return (
    <button onClick={out} disabled={busy} data-testid="logout-btn"
      className={`text-sm transition-colors disabled:opacity-50 ${className}`}>
      {busy ? "Logging out…" : "Log out"}
    </button>
  );
};
